import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles,
    TextField,
    useInputForm,
    SelectField,
    DateTimePickerField,
} from "../../../../Components/Inputs";
import {clearInputFormFields, createYesNoList} from "../../../../Components/Inputs/inputUtility";
import {gridConstants, GridContainer, GridCell} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {LOAN_LIBRARY_LOAN_STATUS_LIST} from "../../../Loan/LoanLibrary/LoanManagement/loanLibraryLoanConstants";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {getLoggedInUser, isRmtcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface LoanLibraryHistorySearchFormViewProps {
    dropDowns: Record<string, any>;
    handleSetSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
    searchCriteria: Record<string, any>;
}
interface DropdownShippingLocation {
    shippingLocationId: string;
    name: string;
    userId: string;
}

export const LoanLibraryHistorySearchFormView = ({
                                                     dropDowns,
                                                     handleSetSearchCriteria,
                                                     isLoading,
                                                     searchCriteria,
                                                 }: LoanLibraryHistorySearchFormViewProps) => {

    const searchForm = useInputForm(searchCriteria);

    const patrons = createListFromArrayOfObjects(dropDowns.patrons, "userId", "fullName");

    const filteredShippingLocations = !isRmtcAdmin()
        ? dropDowns.shippingLocations.filter((sl: DropdownShippingLocation) => sl.userId == getLoggedInUser()) 
        : dropDowns.shippingLocations;
    const shippingLocations = createListFromArrayOfObjects(filteredShippingLocations, "shippingLocationId", "name");
    
    const districts = createListFromArrayOfObjects(dropDowns.districts, "districtId", "districtName");
    const organizations = createListFromArray(dropDowns?.organizations);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedSearchCriteria = {...searchCriteria};
        updatedSearchCriteria.ClearLoanLibraryHistorySearch();
        handleSetSearchCriteria(updatedSearchCriteria);
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedSearchCriteria = {...searchCriteria};
        updatedSearchCriteria.Search(criteria);
        handleSetSearchCriteria(updatedSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.THREE,
    };

    return (
        <>
            <InputForm name="loanLibraryHistorySearch" hasPaddingY>
                <TextField
                    {...searchForm.searchTerm}
                    {...inputSharedSettings}
                    label="Search"
                    placeholder="Title, Catalog Number, or Barcode"
                />

                {
                    isRmtcAdmin() &&
                    <SearchableSingleSelectField
                        {...searchForm.patronId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label={'Patron'}
                        options={patrons}
                    />
                }

                {
                    shippingLocations &&
                    <SearchableSingleSelectField
                        {...searchForm.shippingLocationId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label="Shipping Location"
                        options={shippingLocations}
                    />
                }

                <DateTimePickerField
                    {...searchForm.dueDate}
                    {...inputSharedSettings}
                    label={'Due Date'}
                />

                <SelectField
                    {...searchForm.loanLibraryLoanStatus}
                    {...inputSharedSettings}
                    label="Status"
                    options={LOAN_LIBRARY_LOAN_STATUS_LIST}
                />

                <SelectField
                    {...searchForm.isOverdue}
                    {...inputSharedSettings}
                    includeDefaultOption
                    options={createYesNoList()}
                />

                {
                    isRmtcAdmin() &&
                    <>
                        <SearchableSingleSelectField
                            {...searchForm.districtId}
                            {...inputSharedSettings}
                            includeDefaultOption
                            label={'District'}
                            options={districts}
                        />

                        <SearchableSingleSelectField
                            {...searchForm.organization}
                            {...inputSharedSettings}
                            includeDefaultOption
                            options={organizations}
                        />
                    </>
                }


                <GridCell>
                    <GridContainer hasPaddingX isFlush isReverseOrder>
                        <GridCell medium_columns={gridConstants.column.FOUR}>
                            <Button
                                buttonType={inputStyles.button.types.SEARCH}
                                disabled={isLoading}
                                label="Search"
                                name="btnSearchLoanLibraryHistory"
                                onClick={handleSearchClick}
                                isPrimary
                            />
                        </GridCell>

                        <GridCell medium_columns={gridConstants.column.FOUR}>
                            <Button
                                buttonType={inputStyles.button.types.CLEAR}
                                disabled={isLoading}
                                name="btnClearLoanLibraryHistorySearch"
                                onClick={handleClearClick}
                                label="Clear"
                            />
                        </GridCell>
                    </GridContainer>
                </GridCell>
            </InputForm>
        </>
    );
};

